/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import { lazyWithRetry} from "./ComponentLoader";

const { isAuthenticated } = {};

const LandingPage = lazyWithRetry(() => import("../pages/LandingPage"));

const CollectionsPage = lazyWithRetry(() => import("../pages/Collectibles"));

const ProductDetailPage = lazyWithRetry(() => import("../pages/ProductDetail"));
const WalletPage = lazyWithRetry(() => import("../pages/MyWallet"));

const TermsPage = lazyWithRetry(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazyWithRetry(() => import("../pages/PrivacyPolicy"));
const ScrollToTop = lazyWithRetry(() => import("./ScrollToTop"));
const MyProfilePage = lazyWithRetry(() => import("../pages/MyProfile"));
const MyTransactionPage = lazyWithRetry(() => import("../pages/MyTransactions"));
const MyProductDetailpage = lazyWithRetry(() => import("../pages/MyProductDetail"));
const UserProductsPage = lazyWithRetry(() => import("../pages/UserProducts"));
const ProductTransactionDetailPage = lazyWithRetry(
    () => import("../pages/ProductTransactionDetail")
);
const LogoutPage = lazyWithRetry(() => import("../pages/Logout"));
const SignUpPage = lazyWithRetry(() => import("../pages/SignUp"));
 
const RouterConfig = (props) => (
    <Switch>
        <Route exact path="/" component={LandingPage} />
        {/* <Route exact path="/collection/entertainment" component={EntertainmentPage} />
        <Route exact path="/collection/sports" component={SportsPage} /> */}
        <Route path="/collection/:category" component={CollectionsPage} />
        <Route
            path="/assets/:address/:id"
            component={ProductDetailPage}
        />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route exact path="/my-wallet" component={WalletPage} />
        <Route exact path="/my-profile" component={MyProfilePage} />
        <Route exact path="/my-transactions" component={MyTransactionPage} />
        <Route path="/creds/create-account" component={MyProfilePage} />
        <Route
            path="/my-assets/:address/:id"
            component={MyProductDetailpage}
        />
        <Route exact path="/logout" component={LogoutPage} />
        <Route exact path="/signup" component={SignUpPage} />
        <Route
            exact
            path="/tx/:address/:id"
            component={ProductTransactionDetailPage}
        />        
        <Route exact path="/:id(.*)" component={UserProductsPage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW 
            loaderText={"Vantr"}
            />}>
                <ScrollToTop />
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
